import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=logged in

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data.user)).catch(() => setUser(false));
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user);
      return r.data.user;
    } catch {
      return null;
    }
  }, []);

  // presence heartbeat while logged in
  const userId = user && user.id;
  useEffect(() => {
    if (!userId) return;
    const ping = () => api.post("/presence/heartbeat", { status: "online" }).catch(() => {});
    ping();
    const t = setInterval(ping, 20000);
    return () => clearInterval(t);
  }, [userId]);

  const appUserLogin = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ss_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const appUserRegister = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("ss_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const appUserLogout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("ss_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, refreshUser, appUserLogin, appUserRegister, appUserLogout }}>
      {children}
    </AuthContext.Provider>
  );
}
